import { useNotify, Button, useRefresh, required, ReferenceInput, SelectInput } from "react-admin";
import { parse, isValid } from "date-fns";
import RoomPreferences from "@mui/icons-material/RoomPreferences";
import { candidateRequests } from "api/candidateApi";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { formatDateBg } from "server/formatting/formatDateBg";

const ExamSlotDialog = ({ campaignExamId, candidacyId, slotId, disabled }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async data => {
    await dataProvider.customRequest(
      candidateRequests.changeCandidacyExamSlot(candidacyId, campaignExamId),
      { examSlotId: data.slotId },
      "PUT",
    );
    notify("Успешна промяна", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Разместване на кандидати по зали, дати и часове"
      onConfirm={handleSubmit}
      defaultValues={{ slotId }}
      triggerButton={
        <Button
          startIcon={<RoomPreferences />}
          variant="contained"
          disabled={disabled}
          label="Разместване на кандидати по зали"
        />
      }
    >
      <ReferenceInput
        source="slotId"
        reference={candidateRequests.getExamSlotsSelect()}
        filter={{ campaignExamId: campaignExamId }}
      >
        <SelectInput
          label="Зала и час на изпит"
          optionText={rec => {
            const startRaw = rec.startTime;
            const endRaw = rec.endTime;
            const startDate = startRaw ? parse(startRaw, "dd.MM.yyyy HH:mm", new Date()) : null;
            const endDate = endRaw ? parse(endRaw, "dd.MM.yyyy HH:mm", new Date()) : null;

            const start = startDate && isValid(startDate) ? formatDateBg(startDate) : "";
            const end = endDate && isValid(endDate) ? formatDateBg(endDate) : "";
            return (
              <span style={{ whiteSpace: "pre-line", display: "block" }}>
                {rec.roomName || ""} - {rec.buildingName || ""}({rec.capacity})
                <br />
                Начало на изпит: {start}
                {end && (
                  <>
                    <br />
                    Край на изпит: {end}
                  </>
                )}
              </span>
            );
          }}
          validate={[required()]}
        />
      </ReferenceInput>
    </FormModal>
  );
};

export default ExamSlotDialog;
